/**
 * Components: Schema Class Tree.
 *
 * @since 1.0.0
 */
/*
 * External dependencies.
 */
import React from "react";
import { Set } from "immutable";

/*
 * Internal dependencies.
 */
import Tree from "../Tree";

class SchemaClassTree extends React.Component {
  constructor(props) {
    super(props);

    console.debug("SchemaClassTree c'tor", { props });

    this.childrenSelector = this.childrenSelector.bind(this);

    this.leafDecorator = props.leafDecorator || (Component => Component);
  }

  childrenSelector(parent, items) {
    return items.filter(
      item => -1 < parent.children.map(child => child.id).indexOf(item.id)
    );
  }

  render() {
    return (
      <Tree
        roots={this.props.roots}
        childrenSelector={this.childrenSelector}
        leafDecorator={this.props.leafDecorator}
        items={this.props.items}
        isSelected={this.props.isSelected}
        isOpen={this.props.isOpen}
        toggleSelected={this.props.toggleSelected}
        toggleOpen={this.props.toggleOpen}
      />
    );
  }
}

export default SchemaClassTree;
